import React, { useState, useEffect } from 'react';
import GaugeChart from 'react-gauge-chart';
import FeatherIcon from 'feather-icons-react';
import PropTypes from 'prop-types';
import { InfoCircleOutlined } from '@ant-design/icons';
import { message, Spin } from 'antd';
import { getScoringDetails } from '../../../Api/Services/CommonApiService'
import { LeadDetailData } from '../../../Api/Services/LeadApiServices'
import { FetchAccountDetails } from '../../../Api/Services/AccountApiService'
import { FetchDealDetails } from '../../../Api/Services/DealApiService'
import { FetchContactDetails } from '../../../Api/Services/ContactApiService'

const MyGauge = ({ UrlId, trigger }) => {
    const [actualValue, setActualValue] = useState("0")
    const [maxValue, setMaxValue] = useState(0)
    const [graphValue, setGraphValue] = useState(0)
    const [graphStataus, setGraphStataus] = useState("")
    const [graphDif, setGraphDif] = useState()
    const [graphTValue, setGraphTValue] = useState(0)
    function getScoreChangeInfo(currentScore, lastWeekScore) {
        const toSafeNumber = (val) => {
            const num = parseFloat(val);
            return Number.isNaN(num) ? 0 : num;
        };

        const safeCurrent = toSafeNumber(currentScore);
        const safeLastWeek = toSafeNumber(lastWeekScore);

        let percentageChange = 0;
        let isIncrease = false;

        if (safeLastWeek === 0 && safeCurrent === 0) {
            percentageChange = 0;
            isIncrease = false;
        } else if (safeLastWeek === 0) {
            percentageChange = 100;
            isIncrease = true;
        } else {
            const difference = safeCurrent - safeLastWeek;
            percentageChange = (difference / safeLastWeek) * 100;
            isIncrease = difference > 0;
        }
        return {
            percentageChange: Number(percentageChange.toFixed(2)),
            isIncrease,
        };
    }
    function getGraphValue(score, max) {
        const toSafeNumber = (val) => {
            const num = parseFloat(val);
            return Number.isNaN(num) ? 0 : num;
        };

        const safeScore = toSafeNumber(score);
        const safeMax = toSafeNumber(max);

        if (safeScore === 0 || safeMax === 0) return 0;

        return safeScore / safeMax;
    }
    async function getDetailData(params) {
        try {
            const responseData = await LeadDetailData(params);
            const response = responseData.data
            const ScoringData = await getScoringDetails("Lead", UrlId[1])
            const dataScore = response?.leadScore;
            const HighScore = response?.higerScore;
            const thresholdScore = response?.thresholdScore;
            const thresholdState = response?.thresholdState;
            const isValidTScore = thresholdScore && thresholdScore !== "" && thresholdScore !== "NaN";
            const isValidScore = HighScore && HighScore !== "" && HighScore !== "NaN";
            const isValidDScore = dataScore && dataScore !== "" && dataScore !== "NaN";
            const isValidState = thresholdState && thresholdState !== "" && thresholdState !== "NaN";
            const finalTscrore = isValidTScore ? Number(thresholdScore) : 0;
            const finalMax = isValidScore ? Number(HighScore) : 0;
            const validnumber = isValidDScore ? Number(dataScore) : 0;
            let finalState = "N/A";

            if (isValidTScore && isValidDScore) {
                finalState = finalTscrore <= validnumber
                    ? "Hot"
                    : isValidState
                        ? thresholdState
                        : "Hot"; // fallback to Hot if no thresholdState
            }
            // const finalState = isValidTScore ?
            //     isValidScore ?
            //         isValidState
            //             ?
            //             finalTscrore > validnumber ? "Hot" :
            //                 thresholdState
            //             : "Hot"
            //         : "N/A"
            //     : "N/A"

            const ResponseForCalculation = getScoreChangeInfo(validnumber, ScoringData?.score)
            const graphv = getGraphValue(validnumber, finalMax)
            setMaxValue(Math.round(finalMax))
            setGraphValue(graphv)
            setGraphTValue(finalTscrore)
            setGraphStataus(finalState)
            setGraphDif(ResponseForCalculation)
            setActualValue(validnumber)
        } catch (error) {
            message.error(error);
        }
    }
    async function getAccountDetailData(params) {
        try {
            const responseData = await FetchAccountDetails(params);
            const response = responseData.data
            const ScoringData = await getScoringDetails("Account", UrlId[1])
            const dataScore = response?.accountScore;
            const HighScore = response?.higerScore;
            // const thresholdScore = response?.thresholdScore;
            const thresholdScore = response?.higerScore;
            const thresholdState = response?.thresholdState;
            const isValidTScore = thresholdScore && thresholdScore !== "" && thresholdScore !== "NaN";
            const isValidScore = HighScore && HighScore !== "" && HighScore !== "NaN";
            const isValidDScore = dataScore && dataScore !== "" && dataScore !== "NaN";
            const isValidState = thresholdState && thresholdState !== "" && thresholdState !== "NaN";
            const finalTscrore = isValidTScore ? Number(thresholdScore) : 0;
            const finalMax = isValidScore ? Number(HighScore) : 0;
            const validnumber = isValidDScore ? Number(dataScore) : 0;
            let finalState = "N/A";

            if (isValidTScore && isValidDScore) {
                finalState = finalTscrore <= validnumber
                    ? "Hot"
                    : isValidState
                        ? thresholdState
                        : "Hot"; // fallback to Hot if no thresholdState
            }
            const ResponseForCalculation = getScoreChangeInfo(validnumber, ScoringData?.score)
            const graphv = getGraphValue(validnumber, finalMax)
            setMaxValue(Math.round(finalMax))
            setGraphValue(graphv)
            setGraphTValue(finalTscrore)
            setGraphStataus(finalState)
            setGraphDif(ResponseForCalculation)
            setActualValue(validnumber)
        } catch (error) {
            message.error(error);
        }
    }
    async function getDealDetailData(params) {
        try {
            const dealresponse = await FetchDealDetails(params);
            const response = dealresponse.data
            const ScoringData = await getScoringDetails("Deal", UrlId[1])
            const dataScore = response?.dealScore;
            const HighScore = response?.higerScore;
            const thresholdScore = response?.thresholdScore;
            const thresholdState = response?.thresholdState;
            const isValidTScore = thresholdScore && thresholdScore !== "" && thresholdScore !== "NaN";
            const isValidScore = HighScore && HighScore !== "" && HighScore !== "NaN";
            const isValidDScore = dataScore && dataScore !== "" && dataScore !== "NaN";
            const isValidState = thresholdState && thresholdState !== "" && thresholdState !== "NaN";
            const finalTscrore = isValidTScore ? Number(thresholdScore) : 0;
            const finalMax = isValidScore ? Number(HighScore) : 0;
            const validnumber = isValidDScore ? Number(dataScore) : 0;
            let finalState = "N/A";

            if (isValidTScore && isValidDScore) {
                finalState = finalTscrore <= validnumber
                    ? "Hot"
                    : isValidState
                        ? thresholdState
                        : "Hot"; // fallback to Hot if no thresholdState
            }
            const ResponseForCalculation = getScoreChangeInfo(validnumber, ScoringData?.score)
            const graphv = getGraphValue(validnumber, finalMax)
            setMaxValue(Math.round(finalMax))
            setGraphValue(graphv)
            setGraphTValue(finalTscrore)
            setGraphStataus(finalState)
            setGraphDif(ResponseForCalculation)
            setActualValue(validnumber)
        } catch (error) {
            message.error(error);
        }
    }
    async function getContactDetailData(params) {
        try {
            const responseData = await FetchContactDetails(params);
            const response = responseData.data
            const ScoringData = await getScoringDetails("Contact", UrlId[1])
            const dataScore = response?.contactScore;
            const HighScore = response?.higerScore;
            const thresholdScore = response?.thresholdScore;
            const thresholdState = response?.thresholdState;
            const isValidTScore = thresholdScore && thresholdScore !== "" && thresholdScore !== "NaN";
            const isValidScore = HighScore && HighScore !== "" && HighScore !== "NaN";
            const isValidDScore = dataScore && dataScore !== "" && dataScore !== "NaN";
            const isValidState = thresholdState && thresholdState !== "" && thresholdState !== "NaN";
            const finalTscrore = isValidTScore ? Number(thresholdScore) : 0;
            const finalMax = isValidScore ? Number(HighScore) : 0;
            const validnumber = isValidDScore ? Number(dataScore) : 0;
            let finalState = "N/A";

            if (isValidTScore && isValidDScore) {
                finalState = finalTscrore <= validnumber
                    ? "Hot"
                    : isValidState
                        ? thresholdState
                        : "Hot"; // fallback to Hot if no thresholdState
            }
            const ResponseForCalculation = getScoreChangeInfo(validnumber, ScoringData?.score)
            const graphv = getGraphValue(validnumber, finalMax)
            setMaxValue(Math.round(finalMax))
            setGraphValue(graphv)
            setGraphTValue(finalTscrore)
            setGraphStataus(finalState)
            setGraphDif(ResponseForCalculation)
            setActualValue(validnumber)
        } catch (error) {
            message.error(error);
        }
    }
    useEffect(() => {
        if (trigger !== "") {
            if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD") {
                getDetailData(UrlId[1])
            }
            else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL") {
                getDealDetailData(UrlId[1])
            }
            else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT") {
                getContactDetailData(UrlId[1])
            }
            else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT") {
                getAccountDetailData(UrlId[1])
            }
        }
    }, [UrlId, trigger])
    return (
        <>
            {(actualValue !== undefined && actualValue !== null && actualValue !== "" && actualValue !== "0") ? (
                <div
                    style={{
                        display: 'flex',
                        alignItems: "center",
                    }}
                >
                    <div style={{ position: 'relative', width: '59%', }}>
                        <GaugeChart
                            id="dynamic-gauge"
                            nrOfLevels={30}
                            colors={['#00FF00', '#FFBF00', '#FF0000']}
                            textColor="#000"
                            percent={Math.min(graphValue, 1.05)}
                            arcWidth={0.3}
                            needleBaseColor="#333"
                            needleColor="#888"
                            hideText
                        />
                        <div
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                color: '#000',
                            }}
                        >
                            {actualValue ? Number(actualValue)?.toFixed(2) : 0}
                        </div>
                        <div
                            style={{
                                position: 'absolute',
                                bottom: '0px',
                                right: '0.5vw',
                                fontSize: '12px',
                                fontWeight: 'bold',
                                color: 'black',
                            }}
                        >
                            {maxValue || 0} <InfoCircleOutlined style={{ fontSize: "10px", color: '#0000009c', cursor: 'pointer', margin: "0px 3px" }} title="Highest Score" />
                        </div>
                    </div>
                    <div style={{ width: '1%' }}>
                        <div style={{ width: '1px', height: '9vh', background: "#adb4d2" }} />
                    </div>
                    <div style={{
                        width: "40%", padding: "10px 0px 00px", display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                        alignItems: "center",
                    }}>
                        <span
                            style={{
                                fontSize: '16px',
                                fontWeight: 'bold',
                                color: graphStataus?.toLowerCase()?.startsWith('cold')
                                    ? '#00b900'
                                    : graphStataus?.toLowerCase()?.startsWith('warm')
                                        ? '#ffbc00'
                                        : graphStataus?.toLowerCase()?.startsWith('hot')
                                            ? '#FF0000'
                                            : '#adb4d2',
                            }}
                        >
                            {(graphStataus?.toLowerCase()?.startsWith('cold') || graphStataus?.toLowerCase()?.startsWith('warm') || graphStataus?.toLowerCase()?.startsWith('hot')) ?
                                graphStataus : "Undefined"}
                        </span>
                        <span style={{ display: "flex", alignItems: "center", fontSize: '12px', fontWeight: 700 }}>
                            <span style={{
                                marginRight: 2,
                                color: graphStataus?.toLowerCase()?.startsWith('cold')
                                    ? '#00b900'
                                    : graphStataus?.toLowerCase()?.startsWith('warm')
                                        // ? '#FFBF00'
                                        ? '#ffbc00'
                                        : graphStataus?.toLowerCase()?.startsWith('hot')
                                            ? '#FF0000'
                                            : '#adb4d2',
                            }}> {Number(actualValue)?.toFixed(2)} </span> /
                            <span style={{
                                marginRight: 2,
                                color: "#407fe9",
                            }}> {Number(graphTValue)?.toFixed(2)} </span>
                            <InfoCircleOutlined style={{ fontSize: "10px", color: '#0000009c', cursor: 'pointer', margin: "0px 3px" }} title="Predictive Conversion Threshold" /></span>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: "center",
                                fontSize: '10px',
                                marginBottom: '5px',
                                color: graphDif?.isIncrease ? 'green' : 'red',
                            }}
                        >
                            <span style={{ display: "flex", alignItems: "center" }}><FeatherIcon icon={graphDif?.isIncrease ? "arrow-up" : "arrow-down"} size={10} />{Math.abs(graphDif?.percentageChange).toFixed(0)}%</span>
                            <span style={{ color: '#666', marginLeft: '5px', fontSize: "8px" }}>
                                Since last week
                            </span>
                        </div>
                    </div>
                </div>
            ) : (
                <div style={{ padding: "15%", textAlign: "center" }}>
                    <Spin />
                </div>
            )}
        </>

    );
};

MyGauge.propTypes = {
    UrlId: PropTypes.array.isRequired,
    // NacTrigger: PropTypes.string.isRequired,
    trigger: PropTypes.string.isRequired,
};

export default React.memo(MyGauge);



